export default __webpack_public_path__ + "static/media/binary.ae6fe510.svg";